import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import { MatTableDataSource } from "@angular/material/table";
import {PROJET_ANNEE_AVIS_MARIN, PROJET_ANNEE_STATUS} from "../../constant/constant";
import {
  TrimestreEnum,
  TypeDossierEnum,
  TableProcessedEnum
} from "../../constant/enum";
import {IProjetAnnee, ProjetAnnee} from '../../model/projet-annee.model';
import { Router } from "@angular/router";
import { MatSort } from '@angular/material/sort';
import { ISortParams } from '../../model/sort-params.model';
import { element } from 'protractor';
import { IProjetAnneeFcTrimestre } from '../../model/projet-annee-fc-trimestre.model';
import {ProjetAnneeAvis} from "../../model/projet-annee-avis.model";
import {getProjetAnneeVisaMarinStatusText} from "../../util/form-validator.utils";
import {MatMenuTrigger} from "@angular/material/menu";
import {getNombreProjetAnneeDiscussionSujetsOuverts} from "../../util/projet-annee-utils";

@Component({
    selector: 'ddc-projets-annee-information-table',
    templateUrl: './projets-annee-information-table.component.html',
    styleUrls: ['./projets-annee-information-table.component.scss'],
    standalone: false
})
export class ProjetsAnneeInformationTableComponent implements OnInit, OnChanges {

  @Input() set projetsAnnee(projetsAnnee: IProjetAnnee[]) {
    this._projetsAnnee = projetsAnnee;
  }

  @Input() set projetsAnneeDisplayedColumns(projetsAnneeDisplayedColumns: string[]) {
    this._projetsAnneeDisplayedColumns = projetsAnneeDisplayedColumns;
  }

  @Output() updateSortParams = new EventEmitter();

  _projetsAnnee: IProjetAnnee[] = [];
  _projetsAnneeDisplayedColumns: string[];
  TypeDossierEnum = TypeDossierEnum;
  TableProcessedEnum = TableProcessedEnum;

  projetsAnneeTableDataSource = new MatTableDataSource([]);
  TrimestreEnum = TrimestreEnum;

  constructor(protected router: Router) {
  }

  ngOnInit() {
    this.initDeclarationsTableDataSource();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initDeclarationsTableDataSource();
  }

  initDeclarationsTableDataSource() {
    this.projetsAnneeTableDataSource.data = this._projetsAnnee || [];
  }

  getStatusFicheInitiale(status) {
    const element = PROJET_ANNEE_STATUS.find((item) => item.value == status);
    if (element) return element.text;
    else return "";
  }

  getStatusTrimestre(projetAnnee: IProjetAnnee, trimestre: TrimestreEnum) {
    if(projetAnnee && projetAnnee.projetAnneeFcTrimestres && projetAnnee.projetAnneeFcTrimestres.length > 0) {
      const projetAnneeFcTrimestre = projetAnnee.projetAnneeFcTrimestres.find((projetAnneeFcTrimestre:IProjetAnneeFcTrimestre) => projetAnneeFcTrimestre.trimestre.code === trimestre);
      if(projetAnneeFcTrimestre) {
        const statutS = PROJET_ANNEE_STATUS.find((item) => item.value === projetAnneeFcTrimestre.statut);
        return statutS ? statutS.text : '';
      }
    }
    return ''
  }

  getProjetAnneeVisaMarinStatus(projetAnnee: IProjetAnnee) {
    if (projetAnnee && projetAnnee.projetAnneeAvis && projetAnnee.projetAnneeAvis.length > 0) {
      const projetAnneeVisaMarin = projetAnnee.projetAnneeAvis.find((projetAnneeVisaMarin : ProjetAnneeAvis) => {
        return projetAnneeVisaMarin.statut
      })
      if(projetAnneeVisaMarin) {
        return getProjetAnneeVisaMarinStatusText(projetAnneeVisaMarin.statut)
      }
    }
    else {
      return 'N/A'
    }
  }

  accessprojetAnnee(projetAnnee) {
    if (projetAnnee && projetAnnee.id) {
        this.router.navigate([`/projet-annee/${projetAnnee.id}`])
    }
  }

  _updateSortParams(sortEvent: MatSort) {
    const sortParams: ISortParams = { sortBy: sortEvent.active, sortDirection: sortEvent.direction};
    this.updateSortParams.emit(sortParams);
  }

    protected readonly getNombreProjetAnneeDiscussionSujetsOuverts = getNombreProjetAnneeDiscussionSujetsOuverts;
}
